
export const MenuKey = {
    /**打开 */
    OPEN: 'open',
    /**分割线 */
    DIVIDER: 'divider',
    /**新增 */
    ADD: 'add',
    /**新建目录 */
    CREATE_DIR: 'create_dir',
    /**移动到 */
    MOVE_TO: 'move_to',
    /**复制到 */
    COPY_TO: 'copy_to',
    /**删除 */
    DELETE: 'delete',
    /**编辑 */
    MODIFY: 'modify',
    /**重命名 */
    RENAME: 'rename',
    /**授权 */
    GRANT: 'grant',
    /**取消授权 */
    CANCEL_GRANT: 'cancel_grant',
    /**分享 */
    SHARE: 'share',
    /**刷新 */
    REFRESH: 'refresh',
};

export const MenuData = {
    [MenuKey.OPEN]: { label: '打开' },
    [MenuKey.DIVIDER]: { label: '' },
    [MenuKey.ADD]: { label: '新增' },
    [MenuKey.CREATE_DIR]: { label: '新建目录' },
    [MenuKey.MOVE_TO]: { label: '移动到' },
    [MenuKey.COPY_TO]: { label: '复制到' },
    [MenuKey.DELETE]: { label: '删除' },
    [MenuKey.MODIFY]: { label: '编辑' },
    [MenuKey.RENAME]: { label: '重命名' },
    [MenuKey.GRANT]: { label: '授权' },
    [MenuKey.CANCEL_GRANT]: { label: '取消授权' },
    [MenuKey.SHARE]: { label: '分享' },
    [MenuKey.REFRESH]: { label: '刷新' },
};
